import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthRoles, hasRole } from '../constants/auth-roles';

export const pressGuard$: CanActivateFn = () => {
  const oidc = inject(OidcSecurityService);
  const router = inject(Router);
  const unauthorized = router.createUrlTree(['/unauthorized']);

  const { userData } = oidc.userData();
  if (!userData) {
    return unauthorized;
  }

  return hasRole(userData, AuthRoles.Press) || hasRole(userData, AuthRoles.SuperAdmin) ? true : unauthorized;
};
